import { Box, Heading, Select, Tab, TabList, TabPanel, TabPanels, Tabs } from "@chakra-ui/react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { AdminEntityType } from "../../autogen/bff-api";
import { AllEntities } from "./all-entities/AllEntities";
import { FencyMigration } from "./fency-migration/FencyMigration";
import { OrgsList } from "./org/OrgsList";

const ENTITY_TYPES = [
  AdminEntityType.Bid,
  AdminEntityType.Contract,
  AdminEntityType.Document,
  AdminEntityType.EmailInvite,
  AdminEntityType.EmailOutboxItem,
  AdminEntityType.Organization,
  AdminEntityType.Person,
  AdminEntityType.SourcingEvent,
  AdminEntityType.Upload,
];

export const Admin = () => {
  const { t } = useTranslation();
  const [selectedAdminEntityType, setSelectedAdminEntityType] = useState<AdminEntityType>();

  return (
    <Box>
      <Heading as="h1" size="lg" color="smText" mb="6">
        {t("Admin dashboard")}
      </Heading>
      <Box bg="smBackground" rounded="xl" border="1px solid" borderColor="smBorder" overflow="hidden">
        <Tabs colorScheme="teal">
          <TabList borderBottom="1px solid" borderColor="smBorder" px="2">
            <Tab>{t("Organizations")}</Tab>
            <Tab>{t("Raw JSON")}</Tab>
            <Tab>{t("Fency migration")}</Tab>
          </TabList>

          <TabPanels>
            <TabPanel px={{ base: "3", md: "5" }}>
              <OrgsList />
            </TabPanel>
            <TabPanel px={{ base: "3", md: "5" }}>
              <Select
                value={selectedAdminEntityType}
                placeholder={t("Select entity type") ?? undefined}
                maxW="sm"
                onChange={(e) => setSelectedAdminEntityType(e.target.value as AdminEntityType)}
              >
                {ENTITY_TYPES.map((entityType) => (
                  <option key={entityType} value={entityType}>
                    {entityType}
                  </option>
                ))}
              </Select>
              {selectedAdminEntityType && <AllEntities entityType={selectedAdminEntityType} />}
            </TabPanel>
            <TabPanel px={{ base: "3", md: "5" }}>
              <FencyMigration />
            </TabPanel>
          </TabPanels>
        </Tabs>
      </Box>
    </Box>
  );
};
